import React from 'react';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, Link } from 'react-router-dom';
import CustomAppBar from '../components/CustomAppBar';
import PrimaryButton from '../components/PrimaryButton';
import Navbar from '../components/Navbar';
import TextContainer from '../components/TextContainer';
import AppContainer from '../components/AppContainer';
import StepContainer from '../components/StepContainer';

function NewGroup() {
    const navigate = useNavigate();
    return (
        <AppContainer>
            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight }}>
                <CustomAppBar />
                {/* Box to fill space, pushing button to bottom of screen */}
                <Box style={{ flex: 1 }}>
                    <Navbar />
                    <Box sx={{width: '100%', height: '150px', backgroundColor: '#96D0F6'}} />
                    <TextContainer>
                        <Typography variant='h5' sx={{marginTop: '20px'}}>Make a new group</Typography>
                        <StepContainer number={1}>Name the group</StepContainer>
                        <StepContainer number={2}>Add devices to group</StepContainer>
                        <StepContainer number={3}>Send invite code to add others</StepContainer>
                    </TextContainer>
                </Box>
                {/* Button at the bottom of the screen */}
                <TextContainer customStyles={{marginBottom: '40px'}}>
                    <PrimaryButton text={"Next"} customStyles={{width: '100%'}} onClick={() => {navigate('/new-group/name')} }/>
                </TextContainer>
            </Box>
        </AppContainer>
    )
}

export default NewGroup